<template>
    <div class="mt-5 mb-5">
      <vs-table :data="weeklySearchresult" class="stickyCol-tbl">
          <template slot="header">
              <!-- <div class="datepicker-main">
                  <div class="datewrapper">
                  <label for class="float-right w-auto">Select Week Date</label>
                  <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                      placeholder="Select Date"
                      class="float-right calendar-icon-right top-45"
                      format="dd/MM/yyyy"
                      v-model="current_date"
                      @change="dateweek()"
                      :disabledDates="disabledDates"
                  ></datepicker>
                  </div>
              </div> -->
              <div v-if="$store.state.uInfo.role !== 'U'" class="total-hours">
                  Total Hours:
                  <span class="font-bold">{{convertToTime(totalActiveMinutesOfWeek)}}</span>
              </div>
              <!-- <div class="flex mb-4">
                  <vue-json-to-csv :json-data="csvWeekData" :csv-title="'WeekData'">
                  <vs-button class="gradient-btn">
                      <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon>
                  </vs-button>
                  </vue-json-to-csv>
                  <vs-button
                  class="ml-1 gradient-btn"
                  target="_blank"
                  title="Download PDF"
                  @click="generateWeekPDF"
                  >
                  <feather-icon icon="FileTextIcon" class></feather-icon>
                  </vs-button>
              </div> -->
          </template>
          <template slot="thead">
              <vs-th style="min-width: 150px;">User</vs-th>
              <vs-th v-for="(dates,index) in WeekDates" :key="index">
                  {{ dates.Date }}
                  <br />
                  {{ dates.Day }}
              </vs-th>
              <vs-th class="sticky-col totaltime-col">Total Time</vs-th>
              <!-- <vs-th v-if="$store.state.uInfo.role !== 'U'" class="sticky-col totaltime-col dis-block-text" style="width: 10%;">
                <span class="dis-block">Approved</span> -->
                <!-- <vs-button class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-x" title="Is Approve All?" @click.prevent="confirmApprove(current_date,null)"></vs-button> -->
              <!-- <span class="dis-block cursor-pointer"  @click.prevent="confirmApprove(current_date,null)">[ ] All</span>
              </vs-th> -->
              <vs-th
                  v-if="$store.state.uInfo.role !== 'U'"
                  class="sticky-col totaltime-col"
                  style="width: 20%;"
              >Comments</vs-th>
          </template>

          <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    <!-- <vx-tooltip :text="tr.user_name.toUpperCase()"> -->
                      <div class="relative inline-flex float-left">
                          <!--<vs-avatar class="m-0" :src="require(`@/assets/images/portrait/small/avatar-s-11.png`)" size="40px"/>-->
                          <vs-avatar
                          class="m-0"
                          :src="tr.profile_image"
                          size="40px"
                          v-if="tr.profile_image"
                          />
                          <vs-avatar
                          color="primary"
                          class="m-0 name-avatar"
                          :text="usernameList(tr.firstname,tr.lastname)"
                          size="40px"
                          v-else
                          />
                          <div
                          class="h-3 w-3 border-white border border-solid rounded-full absolute pin-r pin-b"
                          :class="'bg-success'"
                          ></div>
                      </div>
                      <h6 class="pt-3 ml-16 break-words">{{ tr.user_name }}</h6>
                    <!-- </vx-tooltip> -->
                  </vs-td>
                  <vs-td v-for="(times,index) in tr.dateWiseData" :key="index">
                      <vx-tooltip text="View timesheet details">
                          <div :class="times.is_user_was_on_leave?'time-box-warning':'time-box'" @click.prevent="openTimesheetSlidebar(tr.user_id,times.date)">
                              <span >{{convertToTime(times.activeMinutes+times.outMinutes)}} {{ times.is_user_was_on_leave?'L':'' }}</span>
                          </div>
                      </vx-tooltip>
                  </vs-td>
                  <vs-td class="sticky-col">{{ convertToTime(tr.totalActiveMinutes + tr.totalOutMinutes) }}</vs-td>
                  <!-- <vs-td v-if="$store.state.uInfo.role !== 'U'"> -->
                    <!-- <vs-button :disabled="!tr.isUnApprovedEditesThere" color="danger" type="filled" icon-pack="feather" icon="icon-x" title="Is Approve?" @click.prevent="confirmApprove(current_date,tr._id)"></vs-button> -->
                    <!-- <span :disabled="!tr.isUnApprovedEditesThere" class=" dis-block cursor-pointer" @click.prevent="confirmApprove(current_date,tr._id)">[ ]</span>
                  </vs-td> -->
                  <vs-td v-if="$store.state.uInfo.role !== 'U'">
                    <!-- <ul class="faq-topics" v-if="tr.editComments.length">
                      <li class="flex items-center" :key="comment_index" v-for="(comm, comment_index) in displayEditComments(tr.editComments)" v-if="comment_index == 0" >
                        <div class="h-3 w-3 rounded-full mr-2 bg-grey"></div>
                        <span class="cursor-pointer">
                          {{comm | shortName(25)}} 
                          <feather-icon icon="PlusIcon" class="text-success h-3" @click.prevent="show_edit_comments = true, edited_comments = displayEditComments(tr.editComments)"></feather-icon>
                        </span>                          
                      </li>
                    </ul> -->
                    <feather-icon v-if="tr.editComments.length" icon="EyeIcon" class="text-success h-3" @click.prevent="show_edit_comments = true, edited_comments = displayEditComments(tr.editComments)"></feather-icon>
                    <span v-else>-</span>
                  </vs-td>
              </vs-tr>
          </template>
      </vs-table>
      <!-- Display Edit timesheet List -->
      <vs-popup class="holamundo" title="Edited Comments" :active.sync="show_edit_comments">
        <div class="overflow-auto mb-5">
          <vs-list :key="comment_index" v-for="(comm, comment_index) in edited_comments">
            <vs-list-item :title="comm"></vs-list-item>
          </vs-list>
        </div>
      </vs-popup>
        <div class="weeklyTimesheetprintpdf hidden">
            <div id="weekprintpdf">
          <table width="100%" style="border-collapse: collapse;width:100%;margin:0px 10px 10px 10px;" id="weekpdfHeader">
            <tbody>
             <tr style="border-collapse: collapse;border:0;">
                  <td style="min-width:90px;max-width:90px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;">Weekly Timesheet</td>
                  <td style="min-width:100px;max-width:100px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;text-align:right;">{{ $store.state.uInfo.org_name }}</td>
              </tr>
            <tr style="border-collapse: collapse;" v-if="office_id">
             <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;">Office: {{ officepdf }} </td> 
            </tr >
            <tr style="border-collapse: collapse;">
              <td style="letter-spacing: 0px;padding:3px 3px;font-size:5px;min-width:100px;color:#000;" colspan="2">Date: <span>{{ WeekDatesstr }}</span></td>
            </tr>
            </tbody>
          </table>
          <table width="100%" style="width:100%;border-collapse: collapse;border:0;margin:0px 10px;" id="weeklypdf">
            <thead>
              <tr style="border-collapse: collapse;border:0;">
                  <th style="letter-spacing: 0px;min-width:55px;max-width:55px;font-size:6px;border: 1px solid #abc0e4;border-right:0 !important;border-collapse: collapse;padding:3px 3px 5px 3px;color:#fff;background:#4472c4;">User</th>
               <th v-for="(dates,index) in WeekDates" :key="index">
                  {{ dates.Date }}
                  <br />
                  {{ dates.Day }}
              </th>
                <th class="sticky-col totaltime-col">Total Time</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="indextr" v-for="(tr, indextr) in weeklySearchresult" style="border-collapse: collapse;border:0;">
                <td>{{ tr.firstname | capitalize}} {{tr.lastname | capitalize}}</td>
                <td v-for="(times,index) in tr.dateWiseData" :key="index">
                  <div class="time-box" @click.prevent="openTimesheetSlidebar(tr.user_id,times.date)">
                    <span>{{convertToTime(times.activeMinutes+times.outMinutes)}}</span>
                  </div>
                </td>
                <td class="sticky-col">{{ convertToTime(tr.totalActiveMinutes + tr.totalOutMinutes) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import "fullcalendar/dist/fullcalendar.css";
import { EventBus } from '@/mixins/mixin.js';
export default {
  components: {
    Datepicker,
    flatPickr,
    jsPDF,
    vSelect,
    "vue-json-to-csv": VueJsonToCsv,
  },
  props: {
    office_id: {
        required: false,
        default: 'all',
        type: String
    },
    department_id: {
        required: false,
        default: 'all',
        type: Array
    },
    current_date: {
      required: true,
      default: new Date(),
    },
    search: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      // disabledDates: {
      //   from: new Date(
      //     new Date().getFullYear(),
      //     new Date().getMonth(),
      //     new Date().getDate() + 1
      //   ) // Disable all dates after specific date
      // },
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      WeeklyTimeSheet: [],
      weeklySearchresult: [],
      WeekDates: [],
      WeekDatesstr:'',
      // current_date: new Date(),
      // format: "dd/MM/yyyy",
      totalActiveMinutesOfWeek: null,
      csvWeekData: [],
      cur_date: null,
      select_user_id: null,
      show_edit_comments: false,
      edited_comments: [],
      officepdf:'',
      weekStartDay:"",
    };
  },
  mounted: function() {
    //this.dateweekStr();
    //this.dateweek();
    /** Reload details when close sidebar */
    EventBus.$on('reload_details', () => {
      this.getWeeklyTimeSheet();
    });
    EventBus.$on("weekTimesheetPDF", () => {
      this.generateWeekPDF();
    });
    this.getDateTimeData();
  },
  watch: {
    office_id(nv) {
      if (nv) {
        this.getOfficeAndDepartment();
      }
        this.getWeeklyTimeSheet();
    },
    department_id(nv) {
    //  if (nv) {
        this.getWeeklyTimeSheet();
      //}
    },
    currentPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getItems();
      }
    },
    current_date(nv) {
      if (nv) {
        this.getDateTimeData();
      }
    },
    search(nv){
      if (!nv) {
        this.perPage = 25;
        this.currentPage = 1;
        this.weeklySearchresult = this.WeeklyTimeSheet;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
      }
      if(nv){
        let result = this.WeeklyTimeSheet.filter(e => {
              if (
                e.firstname.toLowerCase().includes(this.search.toLowerCase()) ||
                e.lastname.toLowerCase().includes(this.search.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            });
            this.weeklySearchresult = result;
      }
    },
  },
  computed: {
    eventSources() {
      const self = this;
      return [
        {
          events(start, end, timezone, callback) {
            setTimeout(() => {
              callback(
                self.MonthlyTimeSheet[0].dateWiseData.map(d => {
                  return {
                    ...d,
                    start: d.date,
                    title: self.convertToTime(d.activeMinutes).toString(),
                    allDay: true
                  };
                })
              );
            }, 1000);
          }
        }
      ];
    }
  },
  methods: {
    dateweekStr() {
      let date = this.current_date;
      let fd = moment(date).isoWeekday(1);
      let ld = moment(date).isoWeekday(7);
       this.WeekDatesstr = moment(fd).format("DD/MM/YYYY")+'-'+moment(ld).format("DD/MM/YYYY");
     
    },
    displayEditComments(data){  
      let result = [];    
      
      if(data.length){
        data.forEach(ele => {
          let resp = this.manageComment(ele.main_status,ele.status,ele.new_value,ele.old_value);
          result.push(resp);
        });
      }
      return result;
    },
    manageComment(main_status,status,from,to){
      let text = '';
      if (main_status == 'CIN' && status == 'IN') {
        text = 'Clock On time : ';
      } 
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Clock Off time : ';
      }
      else if (main_status == 'CIN' && status == 'BI') {
        text = 'Break start time : ';
      } 
      else if (main_status == 'CIN' && status == 'BS') {
        text = 'Break end time : ';
      }
      let from_time =  moment.tz(from, this.timezone).format('hh:mm a');
      let to_time =  moment.tz(to, this.timezone).format('hh:mm a');

      text += 'from '+from_time;
      text += ' to '+to_time;
      return text;
    },
    openTimesheetSlidebar(id,current_date){
      let data = {
        id: id,
        current_date: current_date,
        type: 'week',
        isUserTimeSheet:true,
      }
      EventBus.$emit('open_timesheet_sidebar', data);
    },
    generateWeekPDF() {
      var doc = new jsPDF();
      autoTable(doc, { html: '#weekpdfHeader' })
      autoTable(doc, { html: '#weeklypdf' })
      doc.save("WeekData.pdf")
      // const doc = new jsPDF();
      // var finalY = doc.lastAutoTable.finalY || 10;
      // doc.text("WeekWise Data of User", 14, finalY + 15);
      // let columns = [];
      // this.csvWeekData.forEach(w => {
      //   var keys = Object.keys(w);
      //   keys.forEach(k => {
      //     columns.push({ header: k, dataKey: k });
      //   });
      // });
      // doc.autoTable({
      //   body: this.csvWeekData,
      //   startY: finalY + 20,
      //   columns
      // });
      // doc.save("WeekData.pdf");
    },
    generateActivityWeekPDF() {
      var doc = new jsPDF();
      autoTable(doc, { html: '#pdfHeader' })
      autoTable(doc, { html: '#weeklypdf' })
      doc.save("WeekData.pdf")
      //const doc = new jsPDF();
      // var finalY = doc.lastAutoTable.finalY || 10;
      // doc.text("WeekWise Data of User", 14, finalY + 15);
      // doc.autoTable({
      //   body: this.csvWeekData,
      //   startY: finalY + 20,
      //   columns: [
      //     { header: "User", dataKey: "User" },
      //     { header: "Date", dataKey: "Date" },
      //     { header: "Status", dataKey: "Status" },
      //     { header: "Start Time", dataKey: "Start Time" },
      //     { header: "Notes", dataKey: "Notes" }
      //   ]
      // });
      // doc.save("WeekData.pdf");
    },
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
      /*  return firstname.trim() + " " + lastname.trim(); */
    },
    getDateTimeData() {
      this.$vs.loading({ color: "primary" });

      let url = "oinfo/getInfo";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.weekStartDay = data.week_start_day;
          let startDay = data.week_start_day;
          let endDay = data.week_end_day;        
          let daysWorking = [{day:0,name:'Su',fullname:"Sunday"},{day:1,name:'Mo',fullname:"Monday"},{day:2,name:'Tu',fullname:"Tuesday"},{day:3,name:'We',fullname:"Wednesday"},{day:4,name:'Th',fullname:'Thursday'},{day:5,name:'Fr',fullname:'Friday'},{day:6,name:'Sa',fullname:"Saturday"}];
           let startworkingday = daysWorking.find( ({ name }) => name === startDay );
           let endworkingday = daysWorking.find( ({ name }) => name === endDay );
          let startArr = [];
          let endArr = [];
         for (let index = 0; index < daysWorking.length; index++) {
           if(startworkingday.day  > endworkingday.day) {
             if(index >= startworkingday.day){
               startArr.push(daysWorking[index].fullname);
                }
                if(index <= endworkingday.day){
                  endArr.push(daysWorking[index].fullname);
                }
              }
            else {
              if(startworkingday.day <=index && endworkingday.day >=index){
                startArr.push(daysWorking[index].fullname);
              }  
            }
          }
          this.workingDaysArr =  startArr.concat(endArr);
          let days =["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
          var difference = days.filter(x => !this.workingDaysArr.includes(x));
          difference.forEach(element => {
            this.workingDaysArr.push(element);
          });
          let date = this.current_date;
          let result = [];
          let selectedDayIndex = moment(date).isoWeekday();
          let workIndex = days.indexOf(this.workingDaysArr[0]);
          if(selectedDayIndex >= workIndex){
            let s = moment(date).isoWeekday(this.workingDaysArr[0]);
            let addDate = moment(date).isoWeekday(this.workingDaysArr[0]);
            for (let i = 1; i <= 7; i++) {
            //let s = moment(date).isoWeekday(this.workingDaysArr[i-1]);
            result.push({
              Date: moment(s).format("MMM DD"),
              Day: moment(s).format("ddd"),
              fullDate :moment(s).format("DD/MM/YYYY")
            });
            s = moment(addDate, "DD/MM/YYYY").add(i, 'days');
            }  
          } else {
            let s = moment(date).isoWeekday(this.workingDaysArr[0]);
            let addDate = moment(date).isoWeekday(this.workingDaysArr[0]);
            for (let i = 1; i <= 7; i++) {
              //let s = moment(date).isoWeekday(this.workingDaysArr[i-1]);
                s = moment(addDate, "DD/MM/YYYY").subtract(i, 'days');
              result.push({
                Date: moment(s).format("MMM DD"),
                Day: moment(s).format("ddd"),
                fullDate :moment(s).format("DD/MM/YYYY")
              });
          }
          result = result.reverse();
          }
          this.WeekDatesstr = result[0].fullDate+'-'+result[result.length - 1].fullDate;
          this.WeekDates = result;
          this.$emit('weekdate',this.WeekDates);
          this.getWeeklyTimeSheet();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    dateweek() {
      let date = this.current_date;
      let result = [];
      for (let i = 1; i <= 7; i++) {
        let s = moment(date).isoWeekday(i);
        result.push({
          Date: moment(s).format("MMM DD"),
          Day: moment(s).format("ddd")
        });
      }
      this.WeekDates = result;
      this.getWeeklyTimeSheet();
    },

    convertToTime(totalMinutes) {
      if (totalMinutes) {
        const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
        let hours = addZero(Math.floor(totalMinutes / 60));
        let minutes = addZero(totalMinutes % 60);

        return hours + ":" + minutes;
      } else {
        return "00:00";
      }
    },
    async getWeeklyTimeSheet() {
      this.$vs.loading({
        color: "primary"
      });

      let date = moment.tz(this.current_date, this.timezone).format('DD/MM/YYYY');
      let url = "inout/getWeeklyTimeSheet";
      url += "?fromDate=" + date+"&week_start_day="+ this.weekStartDay;
      if (this.$store.state.uInfo.role == "U") {
        url += "&user_id=" + this.$store.state.uInfo.id;
      } else {
        let office = this.office_id ? this.office_id : 'all';
        let department = this.department_id ? this.department_id.toString() : ''
        url += "&office_id="+office;
        url += "&department_id="+ department;
      }

      return await this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;

          this.WeeklyTimeSheet = data.responseOfWeeklyTimeSheet;
          this.weeklySearchresult = data.responseOfWeeklyTimeSheet;
          this.totalPage = Math.ceil(data.count / this.perPage);
          this.totalActiveMinutesOfWeek = data.totalUserWorkedMinutes;
          for (let j = 0; j < this.WeeklyTimeSheet.length; j++) {
            const parentElement = this.WeeklyTimeSheet[j];
            let myobj = {};
            myobj.User = parentElement.firstname + " " + parentElement.lastname;

            for (let i = 0; i < parentElement.dateWiseData.length; i++) {
              const element = parentElement.dateWiseData[i];

              myobj[
                `${this.WeekDates[i].Date} ${this.WeekDates[i].Day}`
              ] = this.convertToTime(element.activeMinutes);
            }
            this.csvWeekData.push(myobj);
          }
          return true;
        })
        .catch(e => {
          this.showError(e);
          return false
        });
    },
    confirmApprove(cur_date,user_id = null) {
      this.cur_date = cur_date;
      this.select_user_id = user_id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to approve timesheet changes?",
        acceptText: "Approve",
        accept: this.approveTimeSheetChanges
      });
    },
    approveTimeSheetChanges() {
      let office = this.office_id ? this.office_id : 'all';
      let department = this.department_id ? this.department_id : 'all'
      let input = {
        which: 'W',
        date: moment(this.cur_date).format("DD/MM/YYYY"),
        office_id: office,
        department_id: department,
        timeZone: this.timezone,
        user_id: this.select_user_id
      };
      this.$vs.loading({color: "primary"});
      this.axios
        .post("user/approveTimeSheetChanges", input)
        .then(response => {
          if (response) {            
            this.$vs.loading.close();
            let text = "Timesheet has been approved successfully!!!";
            this.$vs.notify({
              text: text,
              color: "success",
              position: "top-right"
            });
            this.getWeeklyTimeSheet();
          }
        })
        .catch(e => {
          this.deleteIndex = 0;
          this.showError(e);
        });
      this.$vs.loading.close();
    },
     getOfficeAndDepartment(){
      if(this.office_id){
          this.$vs.loading({ color: "primary" });
          let url = "office/getAll";
          this.axios
            .get(url)
            .then(response => {
              this.$vs.loading.close();
              let data = response.data.data;
              let selectedOffice = data.filter((i) => i.id == this.office_id);
              this.officepdf = selectedOffice[0].office_name;
            })
            .catch(e => {
              this.showError(e);
            });
      }
     }
  },
  destroyed() {
    EventBus.$off('weekTimesheetPDF');
    EventBus.$off('reload_details');
  },
};
</script>
<style scoped>
.time-box-warning{
    background-color: rgba(var(--vs-warning), 1) !important;
    color: #fff;
    border-radius: 6px;
    width: 100px;
    border: 1px black;
    padding: 5px;
    margin: 2px;
    text-align: center;
    float: left;
}
</style>